
const RowContentSubtitle = ({title}) => {

    return <><h3 className="text-center text-md-start">{title}</h3></>;
}

export default RowContentSubtitle;